<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" style="width: 50%;">
                <div class="modal-header">
                    <slot name="header">
                        <h3 class="form-header">Bag Check In</h3>
                        <button @click="closeModal" class="red-close-button">
                            <i class="pi pi-times" style='padding: 0'></i>
                        </button>
                    </slot>
                </div>
                <div class="modal-body">
                    <slot name="body">
                        <form class="action-modal">
                            <div class="form-section-container" style="grid-template-columns: 1fr 1fr; width: 100%;">
                                <!-- LEFT PANEL: Metadata -->
                                <div class="left-form-section-panel" style="min-height: fit-content; padding-right: 10px;">
                                    
                                    <div style="margin-bottom: 15px;">
                                        <p style="text-align: left; font-weight: bold; margin-bottom: 5px;">Bag Drug Registers <span style="color:red">*</span></p>
                                        <Dropdown
                                            v-model="selectedBag"
                                            ref="bagDropdown"
                                            @keyup="debounceSearchBag"
                                            @focus="onBagFocus"
                                            :loading="loadingBags"
                                            :options="bagList"
                                            optionLabel="name"
                                            :editable="true"
                                            style="width: 100%;"
                                            placeholder="Search Open Bag Checkouts" 
                                        />
                                        <!-- Show selected bag details if selected -->
                                        <div v-if="selectedBag && typeof selectedBag !== 'string'" style="margin-top: 10px; padding: 10px; background-color: #f9f9f9; border-radius: 4px; border: 1px solid #eee;">
                                            <p style="margin: 0; font-size: 0.9em;"><strong>Mission:</strong> {{ selectedBag.mission || 'N/A' }}</p>
                                            <p style="margin: 0; font-size: 0.9em;"><strong>Tag:</strong> {{ selectedBag.tag || 'N/A' }}</p>
                                            <p style="margin: 0; font-size: 0.9em;"><strong>Checked Out By:</strong> {{ selectedBag.executor && selectedBag.executor.personal_information ? selectedBag.executor.personal_information.firstname + ' ' + selectedBag.executor.personal_information.lastname : (selectedBag.executor ? selectedBag.executor.name : 'N/A') }}</p>
                                        </div>
                                    </div>


                                    <div>
                                        <p style="text-align: left; font-weight: bold; margin-bottom: 5px;">Notes</p>
                                        <textarea v-model="notes" rows="6" style="width: 100%; border-radius: 4px; padding: 8px;" placeholder="Optional notes for this checkin..."></textarea>
                                    </div>
                                </div>
                                
                                <!-- RIGHT PANEL: Drugs -->
                                <div class="right-form-section-panel" style="display: flex; flex-direction: column; padding-left: 10px;">
                                    <p style="text-align: left; font-weight: bold; margin-bottom: 5px;">{{ allowManualAdd ? 'Select Medication' : 'Medications In Bag' }} <span v-if="allowManualAdd" style="color:red">*</span></p>

                                    <div v-if="allowManualAdd" class="right-form-section-drug-entry" style="display: flex; margin-bottom: 15px;">
                                        <Dropdown
                                            v-model="stock"
                                            ref="med"
                                            @keyup="debounceSearchDrugs"
                                            @focus="onDrugFocus"
                                            @change="drugSelect"
                                            :loading="loadingDrugs"
                                            :options="drugList"
                                            optionLabel="full_name"
                                            :editable="true"
                                            style="flex: 1; margin-right: 10px;"
                                            :emptyMessage="stockPickerEmptyMessage(stock)"
                                            placeholder="Search Stock"
                                        />
                                        <input v-model="qty" min="0" type="number" placeholder="Qty" style="width: 80px; margin-right: 10px;" />
                                        <p class="submit-button blue-button" style="padding: 10px; margin: 0;" @click="addDrug">Add</p>
                                    </div>

                                    <div class="right-form-section-drug-container" style="overflow-y: auto; max-height: 300px;">
                                        <table style="border-collapse: collapse; width: 100%;" v-if="drugs.length > 0">
                                            <tr>
                                                <th style="text-align: left; padding-bottom: 5px;">Drug</th>
                                                <!-- Two separate figures. In Register is the bag register's balance for the
                                                     drug, which every open check-out into that bag adds to, so it is not this
                                                     check-out's contribution - Put In Bag is. Showing only the first read as
                                                     cumulative and would not add up against anything. -->
                                                <th style="text-align: center; width: 70px;">In Register</th>
                                                <th style="text-align: center; width: 70px;">Put In Bag</th>
                                                <th style="text-align: center; width: 80px;">Return</th>
                                                <th v-if="allowManualAdd" style="width: 40px;"></th>
                                            </tr>
                                            <tr v-for="(item, index) in drugs" :key="index" style="border-bottom: 1px solid #eee;">
                                                <td style="padding: 10px 0; max-width: 250px; cursor: pointer;" 
                                                    @click="expandedDrugs.includes(index) ? expandedDrugs.splice(expandedDrugs.indexOf(index), 1) : expandedDrugs.push(index)"
                                                    :title="expandedDrugs.includes(index) ? 'Click to collapse' : 'Click to expand: ' + item.stock_name">
                                                    <div :style="expandedDrugs.includes(index) ? { whiteSpace: 'normal' } : { display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }">
                                                        {{ item.stock_name }}
                                                    </div>
                                                </td>
                                                <!-- A manually added row is not one the bag has a balance for, so neither
                                                     figure applies to it. Only reachable with allowManualAdd on. -->
                                                <td style="text-align: center;">{{ item.checked_out_qty != null ? item.qty_left : '—' }}</td>
                                                <td style="text-align: center;">{{ item.checked_out_qty != null ? item.checked_out_qty : '—' }}</td>
                                                <td style="text-align: center;">
                                                    <input type="number" v-model="item.qty" min="0" :max="item.max_return_qty != null ? item.max_return_qty : undefined" style="width: 75px; text-align: center;" />
                                                </td>
                                                <td v-if="allowManualAdd" style="text-align: center; padding: 10px 0;">
                                                    <button type="button" @click="removeDrug(index)" class="red-close-button small-button">
                                                        <i class="pi pi-times" style="padding: 0;"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </table>
                                        <p v-else style="color: #666; font-style: italic;">Select a bag to view its medications.</p>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </slot>
                </div>
                <p style="color: red; font-weight: 500; font-size: 1em; text-align: center; margin-top: 10px;" v-if="errorMessage">{{ errorMessage }}</p>
                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 15px 20px;">
                    <slot name="footer">
                        <p class="regular-button error-button" style="color: white; margin-right: 10px;" @click="closeModal">Cancel</p>
                        <p class="regular-button green-button" @click="submitCheckin">Sign Off</p>
                    </slot>
                </div>
            </div>
        </div>
        <SignatureModal v-if="displaySignatureModal" :payload="realSubmit" @isSuccessful="isSuccessful" @close="close" :saveContext="saveContext" endpoint="/bag-checkin" />
    </div>
</template>

<script>
import SignatureModal from '@/components/modals/SignatureModal.vue';
import axios from 'axios';
import { isPickerEmpty, pickerSearchTerm, stockPickerEmptyMessage } from '@/services/pickers';
import { debounce } from 'debounce';
import { decorateStockItems } from '@/services/stockItemDisplay';
import { drugsRequireDoubleSig } from '@/services/doubleSignature';

export default {
    components: {
        SignatureModal
    },
    props: {
        preselectedBagId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            // Adding a medication the check-out never included is off pending clinician advice.
            // The search box, the row delete button and everything behind them are left in place
            // so this is the only line that has to change to bring it back.
            allowManualAdd: false,

            external_number: '',
            tag: '',
            displaySignatureModal: false,
            
            selectedBag: null,
            bagList: [],
            loadingBags: false,

            stock: '',
            drugList: [],
            loadingDrugs: false,
            qty: null,
            
            drugs: [],
            expandedDrugs: [],
            notes: '',
            
            errorMessage: '',
            realSubmit: null,
            saveContext: null
        }
    },
    mounted() {
        if (this.preselectedBagId) {
            this.searchBag();
        }
    },
    watch: {
        selectedBag(newVal) {
            if (newVal && typeof newVal !== 'string') {
                this.populateDrugsFromBag(newVal);
                this.external_number = newVal.mission || '';
                this.tag = newVal.tag || '';
            } else {
                this.drugs = [];
                this.external_number = '';
                this.tag = '';
            }
        }
    },
    computed: {
        requiresDoubleSig() {
            const facility = this.$store.getters.getCurrentLocation?.facility;
            return drugsRequireDoubleSig(this.drugs.filter(d => d.qty > 0), facility);
        }
    },
    methods: {
        stockPickerEmptyMessage,
        formatDrugName(stockItem) {
            if (!stockItem || !stockItem.alias) return 'Unknown Medication';
            const alias = stockItem.alias;
            const generic = alias.generic_name || (alias.generic_drug && alias.generic_drug.name);
            return generic ? `(${generic}) ${alias.name}` : alias.name;
        },
        populateDrugsFromBag(bag) {
            this.drugs = [];
            if (!bag || !bag.units) return;
            
            const groups = {};
            bag.units.forEach(u => {
                if (!u.stock_item) return;
                const key = u.stock_item.uuid;
                if (!groups[key]) {
                    const alias = u.stock_item.alias;
                    let generic = alias && alias.generic_drug ? alias.generic_drug.name : (alias ? alias.name : '');
                    groups[key] = {
                        stock_item: u.stock_item,
                        stock_name: this.formatDrugName(u.stock_item),
                        // The bag's balance, not the ward's. u.stock_item is the row the drug was
                        // drawn out of at checkout, so its qty_left is what the ward has left -
                        // check out a ward's whole holding and that reads 0, which capped the
                        // return at 0 and made the bag impossible to check in.
                        qty_left: u.bag_qty_left || 0,
                        checked_out_qty: 0
                    };
                }
                let current = parseFloat(u.current_qty);
                let quantity = parseFloat(u.quantity);
                groups[key].checked_out_qty += !isNaN(current) ? current : (!isNaN(quantity) ? quantity : 0);
            });
            
            // Only add drugs that have quantity > 0; pre-fill and cap the return qty at
            // whichever is lower - what was checked out, or what the bag is still holding
            // (drugs administered or discarded since checkout reduce the latter).
            this.drugs = Object.values(groups).filter(d => d.checked_out_qty > 0).map(d => {
                d.max_return_qty = Math.min(d.checked_out_qty, d.qty_left);
                d.qty = d.max_return_qty;
                return d;
            });
        },
        closeModal() {
            this.$emit('close', true);
        },
        close(value) {
            if (value) {
                this.displaySignatureModal = false;
            }
        },
        searchBag(fetchDefault = false) {
            this.loadingBags = true;
            axios.post('/open-bag-transfers', {}, this.$store.state.header).then(res => {
                let refined = [];
                const transfers = res.data.data ? res.data.data : res.data;
                if (transfers) {
                    transfers.forEach(transfer => {
                        // Create a formatted display name for the dropdown
                        transfer.name = transfer.bag_location ? transfer.bag_location.name : 'Unknown Bag';
                        if (transfer.mission || transfer.tag) {
                            transfer.name += ` (Mission: ${transfer.mission || '-'} | Tag: ${transfer.tag || '-'})`;
                        }
                        refined.push(transfer);
                    });
                }
                
                // If the user typed a search term, filter locally (optional since open bags are usually few)
                const searchTerm = pickerSearchTerm(this.selectedBag).toLowerCase();
                if (searchTerm !== '') {
                    refined = refined.filter(b => b.name.toLowerCase().includes(searchTerm));
                }

                this.bagList = refined;
                this.loadingBags = false;
                if (this.preselectedBagId && !this.selectedBag) {
                    this.selectedBag = this.bagList.find(b => b.uuid === this.preselectedBagId) || null;
                }
                if (fetchDefault && this.$refs.bagDropdown) {
                    this.$refs.bagDropdown.show();
                }
            }).catch(err => {
                this.loadingBags = false;
                console.error(err);
            });
        },
        debounceSearchBag: debounce(function() {
            this.searchBag(false);
        }, 500),
        onBagFocus() {
            if (isPickerEmpty(this.selectedBag)) {
                this.searchBag(true);
            }
        },
        searchDrugs(fetchDefault = false) {
            const searchTerm = pickerSearchTerm(this.stock);
            if (searchTerm || fetchDefault) {
                this.loadingDrugs = true;
                axios.post('/get-stock-items', { drug: searchTerm }, this.$store.state.header).then(res => {
                    // Check in returns stock to the location, so an item it currently holds none
                    // of is still a valid pick - nothing is disabled on a zero quantity here.
                    this.drugList = decorateStockItems(res.data, { disableZeroStock: false });
                    this.loadingDrugs = false;
                    // Opened on every response, not just the focus preload: an empty result is
                    // what the picker most needs to report, and the message that says so only
                    // renders while the overlay is up.
                    if (this.$refs.med) {
                        this.$refs.med.show();
                    }
                }).catch(err => {
                    this.loadingDrugs = false;
                    console.error(err);
                });
            }
        },
        debounceSearchDrugs: debounce(function() {
            this.searchDrugs(false);
        }, 500),
        onDrugFocus() {
            if (isPickerEmpty(this.stock)) {
                this.searchDrugs(true);
            }
        },
        drugSelect(item) {
            if (typeof item === 'string' || !item) return;
        },
        addDrug() {
            if (!this.stock || typeof this.stock === 'string') {
                this.errorMessage = "Please select a valid medication from the list.";
                return;
            }
            if (!this.qty || this.qty <= 0) {
                this.errorMessage = "Please enter a valid quantity.";
                return;
            }
            
            this.drugs.unshift({
                stock_item: this.stock,
                stock_name: this.formatDrugName(this.stock),
                qty_left: this.stock.qty_left,
                qty: Number(this.qty),
                // Manually added items have no checkout baseline to validate against
                checked_out_qty: null
            });
            
            this.stock = '';
            this.qty = null;
            this.errorMessage = '';
        },
        removeDrug(index) {
            this.drugs.splice(index, 1);
        },
        submitCheckin() {
            if (!this.selectedBag || typeof this.selectedBag === 'string') {
                this.errorMessage = "Bag selection is required.";
                return;
            }
            if (this.drugs.length === 0) {
                this.errorMessage = "At least one medication is required.";
                return;
            }

            const validDrugs = this.drugs.filter(d => Number(d.qty) > 0);

            if (validDrugs.length === 0) {
                this.errorMessage = "At least one medication with a quantity greater than 0 is required.";
                return;
            }

            if (this.drugs.some(d => Number(d.qty) < 0)) {
                this.errorMessage = "Return quantity cannot be negative.";
                return;
            }

            // Items populated from the bag carry an upper bound of whichever is lower -
            // what was checked out, or what the bag is still holding.
            const exceedsCheckout = validDrugs.some(d =>
                d.max_return_qty !== null && d.max_return_qty !== undefined && Number(d.qty) > Number(d.max_return_qty)
            );
            if (exceedsCheckout) {
                this.errorMessage = "Return quantity cannot exceed the checked out quantity or what the bag is still holding.";
                return;
            }

            // Map drugs for backend payload
            const formattedDrugs = validDrugs.map(d => {
                return {
                    stock_item: d.stock_item,
                    qty: Number(d.qty),
                    tags: d.stock_item?.alias?.tags || []
                };
            });

            this.realSubmit = {
                bag_transfer_uuid: typeof this.selectedBag === 'object' && this.selectedBag ? this.selectedBag.uuid : null,
                notes: this.notes,
                drugs: formattedDrugs
            };

            this.saveContext = {
                type: 'Bag Checkin',
                patient: `Mission: ${this.external_number} - Tag: ${this.tag}`,
                location: this.$store.state.currentLocation.name,
                drugs: validDrugs.map(d => ({ drug: d.stock_name, qty: d.qty })),
                doubleSig: this.requiresDoubleSig
            };

            this.errorMessage = '';
            this.displaySignatureModal = true;
        },
        isSuccessful(value) {
            if (value) {
                this.$emit('close', true, 'success');
            }
        }
    }
}
</script>

<style scoped>
/* Inherit global modal styles from main.scss */
/* Hide native spin buttons for number inputs */
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
input[type=number] {
  -moz-appearance: textfield;
}
</style>
